import { Interpolation } from "@emotion/core";
import { transparentize } from "polished";
import { Colors } from "../../../../design-tokens/colors";
import { DarkTheme, Device } from "../../../../design-tokens/media-queries";
import { grid } from "../../../../design-tokens/grid";
import { Fonts } from "../../../../design-tokens/fonts";

const root: Interpolation = {
  paddingBottom: grid(4),
};

const policyRow: Interpolation = {
  position: "relative",
  paddingTop: grid(0.5),
  paddingBottom: grid(1),
  borderBottom: `2px solid ${transparentize(0.95, Colors.Black)}`,

  [DarkTheme]: {
    borderBottom: `2px solid ${transparentize(0.95, Colors.LightGrey)}`,
  },
};

const policyTitle: Interpolation = {
  fontSize: "12px",
  fontWeight: Fonts.Weight.SemiBold,
  marginLeft: grid(2),
  marginBottom: grid(0.5),
};

const barContainer: Interpolation = {
  position: "relative",
  height: grid(2),
  width: "100%",
  overflow: "hidden",
};

const bar: Interpolation = {
  position: "absolute",
  height: grid(2),
  borderRadius: grid(2),
  zIndex: 0,
};

const dot: Interpolation = {
  position: "absolute",
  top: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: grid(2),
  height: grid(2),
  cursor: "pointer",
  zIndex: 5,

  "&::after": {
    content: `''`,
    display: "block",
    flexShrink: 0,
    width: grid(1),
    height: grid(1),
    borderRadius: grid(1),
    transition: "all 0.2s ease",
  },

  [Device.DesktopTablet]: {
    "&:hover": {
      "&::after": {
        width: grid(2),
        height: grid(2),
      },
    },
  },
};

const activeDot: Interpolation = {
  zIndex: 10,

  "&::after": {
    width: grid(2),
    height: grid(2),
    border: `2px solid ${Colors.White}`,
  },
};

const styles = {
  root,
  policyRow,
  policyTitle,
  barContainer,
  bar,
  dot,
  activeDot,
};

export default styles;
